import "./staff.css";
import backup from "../images/teamphotos/fallback-image-HR.avif";
import mikeAmmen from "../images/teamphotos/Mike Ammen Profile photo.avif";
import lisaRamsdell from "../images/teamphotos/Lisa Ramsdell Profile photo.avif";
import christopherJuelfs from "../images/teamphotos/Christopher Juelfs Profile photo.png";

const teamMembers = [
  {
    id: "mike-ammen",
    name: "Mike Ammen",
    role: "President",
    description:
      "As the founder and visionary behind our consulting firm, Michael leads with a commitment to build lasting partnerships, working closely with clients to achieve their sales and operational goals. With a deep understanding of industry challenges, he leads our team in delivering strategic, long-term solutions that drive sustainable growth and success.",
    imageUrl: mikeAmmen || backup,
    linkedIn: "https://www.linkedin.com/in/mikeammen/",
  },
  {
    id: "lisa-ramsdell",
    name: "Lisa Ramsdell",
    role: "Sales & Operations",
    description:
      "Lisa keeps client work aligned and moving, bringing operational rigor to the processes, communication, and execution details that shape durable growth. She also brings over a decade of CRM and data accumulation expertise to help clients build cleaner systems, sharper reporting, and stronger operational decisions.",
    imageUrl: lisaRamsdell || backup,
    linkedIn: "https://www.linkedin.com/in/lisaramsdell/",
  },
  {
    id: "christopher-juelfs",
    name: "Christopher Juelfs",
    role: "Data Analyst",
    description:
      "Christopher transforms raw sales and market data into clear, actionable insight, helping clients uncover trends, evaluate performance, and make smarter business decisions. He brings a distinctive blend of commission-sales instinct, programming skill, and data analysis expertise, connecting frontline business realities to the systems and reporting that improve results.",
    imageUrl: christopherJuelfs || backup,
    linkedIn: "https://www.linkedin.com/in/christopherjuelfs/",
  },
];

const Staff = () => {
  return (
    <section id="staff-section" className="staff-section">
      <div className="section-shell">
        <div className="staff-header">
          <span className="eyebrow">Meet our Leaders</span>
          <h2 className="section-heading">A team with operating depth across strategy, process, and analytics.</h2>
          <p className="section-intro">
            Clients work with experienced operators who understand the details
            behind commercialization, not just the headlines.
          </p>
        </div>

        <div className="staff-content">
          {teamMembers.map((member) => (
            <article key={member.id} className="staff-member surface-card">
              <div className="staff-media">
                <img src={member.imageUrl} alt={member.name} className="staff-image" />
              </div>

              <div className="staff-details">
                <div>
                  <h3 className="staff-name">{member.name}</h3>
                  <p className="staff-role">{member.role}</p>
                </div>
                <a href={member.linkedIn}  target="_blank"  rel="noopener noreferrer"  className="staff-linkedin" >LinkedIn</a>
              </div>

              <p className="staff-description">{member.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Staff;
